/* Generated by tools/build_sections.py from brand/newsletter.js.
   Edit there, not here. */
(function(){if(window.__efEnergy_newsletter)return;window.__efEnergy_newsletter=1;
/* EcoFlow Home Energy — the briefing sign-up.
 *
 * Shopify's /contact with form_type=customer, which creates a customer with
 * marketing consent recorded. That is a real list with a real unsubscribe,
 * which is what lets the designed confirmation keep its promises — it says a
 * briefing will arrive and that unsubscribe is one click, and until there was
 * a list behind it, the whole section shipped disabled rather than say so.
 *
 * Like the quote funnel this is a FORM endpoint, not an API, and it is behind
 * hCaptcha. Measured on the live store 17OCT2026: Shopify only issues a
 * form_key and binds the captcha to a form its own LIQUID rendered, so a form
 * built here is answered 400 "Missing CAPTCHA token" every time -- which is
 * what happened to every sign-up from 12OCT until this was fixed, while the
 * page still said "on the list".
 *
 * So the markup ships a real {% form 'customer' %} and this file fills it and
 * fires a real submit EVENT. form.submit() would not do: it skips listeners,
 * and Shopify's captcha script arms the token on exactly that event. Shopify
 * then redirects back with ?customer_posted=true, and only then is the
 * confirmation shown -- it no longer promises anything it cannot see.
 *
 * The role select becomes a tag, so the list is segmented from the first issue
 * rather than being one undifferentiated pile.
 */
(function () {
  "use strict";

  var doc = document;
  var email = doc.querySelector('[data-eh="nl-email"]');
  var role = doc.querySelector('[data-eh="nl-role"]');
  var submit = doc.querySelector('[data-eh="nl-submit"]');
  if (!email || !submit) return;

  /* The endpoint used to be read from <body>, which worked on the static
     site and silently disabled the whole form once these pages became
     Shopify SECTIONS: a section renders inside the store's layout and can
     never set an attribute on <body>, so the getAttribute returned "" and
     this file returned before binding anything. Subscribe would have looked
     live and done nothing. Read it from the nearest element that declares
     it, and keep <body> as the fallback so the static build still works. */
  var host = submit.closest && submit.closest("[data-nl-endpoint]");
  var endpoint = ((host || doc.querySelector("[data-nl-endpoint]") || doc.body)
                  .getAttribute("data-nl-endpoint") || "").trim();
  if (!endpoint) return;                   /* build disabled it; nothing to do */

  var note = doc.createElement("p");
  note.className = "ef-footnote";
  note.setAttribute("role", "status");
  note.style.cssText = "flex:1 1 100%;margin-top:14px";
  submit.parentNode.insertBefore(note, submit.nextSibling);

  /* The design's own test, kept rather than reinvented: something, an @,
     something, a dot, something. It is deliberately loose — an address that
     looks odd and works is commoner than the reverse. */
  function looksLikeEmail(v) { return /.+@.+\..+/.test(v); }

  var PENDING = "ef-nl-pending";

  function tags() {
    var t = ["newsletter", "home-energy"];
    if (role && role.value) {
      t.push(role.value.toLowerCase().replace(/[^a-z0-9]+/g, "-"));
    }
    return t.join(",");
  }

  submit.addEventListener("click", function (e) {
  /* Visible text goes through T(): the page's ef-i18n-js snippet fills
     window.efT with the reader's language, keyed by this English. */
  var T = function (s) { return (window.efT && window.efT[s]) || s; };
    e.preventDefault();
    var v = (email.value || "").trim();
    if (!looksLikeEmail(v)) {
      note.textContent = T("That email address does not look right — check it and try again.");
      email.focus();
      return;
    }
    var form = doc.getElementById("ef-nl-form");
    if (!form) {
      /* The markup did not ship the Liquid form. Say so rather than pretend:
         a sign-up that silently fails is what this fix exists to end. */
      note.textContent = T("Sorry — the sign-up is not available right now. "
                         + "Email info@gorental.my and we will add you.");
      return;
    }
    var put = function (name, value) {
      var el = form.querySelector('[name="' + name + '"]');
      if (el) el.value = value;
    };
    put("contact[email]", v);
    put("contact[tags]", tags());

    /* The confirmation has to survive the round trip, so the address is handed
       to the next page load in sessionStorage (this tab only) and deleted the
       moment it is read back. */
    try {
      window.sessionStorage.setItem(PENDING, JSON.stringify({ email: v, at: Date.now() }));
    } catch (e) { /* private mode: the sign-up still goes */ }

    note.textContent = T("One moment…");
    submit.disabled = true;

    /* Shopify's inline captcha bootstrap listens for submit on the document
       and CANCELS any protected form that is not yet bound, then loads the
       provider. Measured 17OCT2026: without protect() it cancels and never
       recovers -- the page sits on "Sending..." forever. protect() loads the
       provider, sets data-hcaptchaBound and calls back in ~700ms; submitting
       from inside that callback is the only path that navigates.

       requestSubmit(), not submit(): submit() skips the listeners the token
       is armed on. */
    function go() {
      if (form.requestSubmit) form.requestSubmit();
      else {
        var b = doc.createElement("button");
        b.type = "submit"; b.style.display = "none";
        form.appendChild(b); b.click();
      }
    }
    var cap = window.Shopify && window.Shopify.captcha;
    if (cap && typeof cap.protect === "function") cap.protect(form, go);
    else go();   /* spam protection off: nothing to arm */
  });

  /* Back from Shopify. It redirects here with ?customer_posted=true when it
     accepted the address. The hand-over this tab wrote gates it, so a shared
     or reloaded link shows nothing. */
  (function resume() {
    var params = new URLSearchParams(window.location.search);
    if (params.get("customer_posted") !== "true") return;
    var out = null;
    try {
      out = JSON.parse(window.sessionStorage.getItem(PENDING) || "null");
      window.sessionStorage.removeItem(PENDING);
    } catch (e) { out = null; }
    if (!out || !out.email || Date.now() - (out.at || 0) > 600000) return;
    params.delete("customer_posted");
    var q = params.toString();
    window.history.replaceState(null, "", window.location.pathname + (q ? "?" + q : ""));
    var T = function (s) { return (window.efT && window.efT[s]) || s; };
    note.textContent = T("Thank you — {email} is on the list for the next briefing. "
                       + "Unsubscribe is one click in the footer of every issue.")
                       .replace("{email}", out.email);
    submit.disabled = true;
    email.disabled = true;
    if (role) role.disabled = true;
    var box = submit.closest && submit.closest("form, section, div");
    if (box && box.scrollIntoView) box.scrollIntoView({ block: "center" });
  })();
})();

})();
